
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.36 7.498A11.24 11.24 0 0012.775.01h-.035a11.21 11.21 0 00-9.658 16.896L.049 23.275a.499.499 0 00.667.665l6.37-3.033a11.237 11.237 0 0012.722-.926 11.24 11.24 0 003.553-12.484zm-4.18 11.705a10.238 10.238 0 01-11.803.713.498.498 0 00-.479-.026l-5.342 2.543 2.543-5.341a.503.503 0 00-.026-.479A10.21 10.21 0 0112.739 1.01h.036c4.327 0 8.201 2.739 9.642 6.82a10.238 10.238 0 01-3.236 11.373z"}}),_c('path',{attrs:{"d":"M15.82 13.032H9.692a.5.5 0 00-.5.5c0 1.965 1.599 3.563 3.564 3.563s3.563-1.599 3.563-3.563a.5.5 0 00-.5-.5zm-3.063 3.063a2.57 2.57 0 01-2.516-2.063h5.03a2.567 2.567 0 01-2.515 2.063zM8.16 8.819a.884.884 0 100 1.764.884.884 0 000-1.764z"}}),_c('circle',{attrs:{"cx":"17.352","cy":"9.702","r":".883"}})])
          )
        }
      }
    